import React, { useState, useEffect } from "react";
import { InputSwitch } from "primereact/inputswitch";
import InputTextElementElement from "../../../../Components/UiComponents/InputTextElement";
const TableHeading = (props) => {
  const [fields, setFields] = useState([]);

  useEffect(() => {
    if (props?.fields) {
      setFields(
        props?.fields.map((field) => ({
          ...field,
          // Use field_status here
          placeholder: field.display_name,
        }))
      );
    }
  }, [props.fields]);

  // Function to toggle field_status
  const handleFieldToggle = (index) => {
    setFields(
      fields.map((field, i) =>
        i === index ? { ...field, status: !field.status } : field
      )
    );
    props.getData(
      fields.map((field, i) =>
        i === index ? { ...field, status: !field.status } : field
      )
    );
  };

  const handlePlaceholderChange = (index, value) => {
    setFields(
      fields.map((field, i) =>
        i === index ? { ...field, display_name: value } : field
      )
    );
    props.getData(
      fields.map((field, i) =>
        i === index ? { ...field, display_name: value } : field
      )
    );
  };

  return (
    <div className="p-grid p-fluid">
      {fields.map((field, index) => (
        <div className="p-col-12 p-md-4" key={index}>
          <div className="p-field display-center">
            <div className="w-230">
              <label htmlFor={`field-${index}`} className="p-label">
                {field.ESG_table_name}:
              </label>
            </div>
            <div className="p-inputgroup display-center">
              <div>
                <InputSwitch
                  checked={field?.status}
                  onChange={() => handleFieldToggle(index)}
                />
              </div>
              <InputTextElementElement
                id={`field-${index}`}
                disabled={!field?.status}
                value={field.display_name}
                onChange={(e) => handlePlaceholderChange(index, e.target.value)}
                placeholder={field.placeholder}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TableHeading;
